import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface SinglePieProps {
  title: string;
  data: { name: string; value: number }[];
  colors?: string[];
  onSliceClick?: (name: string) => void;
}

const DEFAULT_COLORS = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
  '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'
];

export const SinglePie: React.FC<SinglePieProps> = ({ 
  title, 
  data, 
  colors = DEFAULT_COLORS,
  onSliceClick
}) => {
  console.log(data);
  // Filter out zero values
  const filteredData = data.filter(item => item.value > 0);
  
  if (filteredData.length === 0) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '2rem'
      }}>
        {title && <h3 style={{ color: '#666', marginBottom: '1rem' }}>{title}</h3>}
        <p style={{ color: '#999' }}>אין נתונים להצגה</p>
      </div>
    );
  }

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
    if (percent < 0.05) return null; // Don't show label for slices smaller than 5%
    
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="white" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize="18"
        fontWeight="bold"
        style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '0',
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      {title && (
        <h3 style={{ 
          color: '#333', 
          marginBottom: '1rem',
          fontSize: '1.2rem'
        }}>
          {title}
        </h3>
      )}
      
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={filteredData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={120}
            fill="#8884d8"
            dataKey="value"
            onClick={onSliceClick ? (data) => onSliceClick(data.name) : undefined}
            style={onSliceClick ? { cursor: 'pointer' } : {}}
          >
            {filteredData.map((entry, index) => (
              <Cell 
                key={`cell-${index}`} 
                fill={colors[index % colors.length]} 
              />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value: number, name: string) => [name, '']}
            labelStyle={{ direction: 'rtl', fontSize: '16px', color: '#000' }}
            contentStyle={{ fontSize: '16px', color: '#000' }}
          />
        </PieChart>
      </ResponsiveContainer>

      <div style={{ 
        marginTop: '0px', 
        textAlign: 'right',
        padding: '0 20px'
      }}>
        {filteredData.map((entry, index) => (
          <div key={entry.name} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            marginBottom: '0px',
            fontSize: '16px',
            fontWeight: '500'
          }}>
            <div style={{
              width: '16px',
              height: '16px',
              backgroundColor: colors[index % colors.length],
              border: '1px solid #ccc',
              flexShrink: 0,
              marginRight: '15px'
            }}></div>
            <span style={{ 
              color: '#000000',
              lineHeight: '18px'
            }}>
              {entry.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
